<template>
  <div class="wrapper">
    <!-- data Table -->
    <div>
      <CRow>
        <CCol col="12" xl="12">
          <CCard class="p-0">
            <CCardHeader
              class="d-flex justify-content-between align-items-center bg-secondary"
            >
              <h5 class="text-light m-0 p-0">گزارش کاربر/دستگاه</h5>
            </CCardHeader>
            <CCardBody>
              <CAlert color="warning" closeButton :show.sync="alert">
                {{ alertText }}
              </CAlert>
              <CRow>
                <div class="col-sm-12 col-md-4">
                  <label class="typo__label">گزارش</label>
                  <multiselect
                    v-model="reportTypeValue"
                    :options="reportTypeList"
                    :multiple="false"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :preserve-search="true"
                    placeholder="انتخاب..."
                    :custom-label="nameWithLang"
                    label="label"
                    track-by="value"
                    :preselect-first="false"
                    selectLabel="انتخاب"
                    deselectLabel="حدف"
                  >
                  </multiselect>
                </div>

                <CCard class="my-2 p-0" v-if="reportTypeValue.value == 1">
                  <CButton
                    block
                    class="text-right shadow-none card-header"
                    @click="showFilter = showFilter === 6 ? false : 6"
                  >
                    <h5 class="text-primary">فیلتر</h5>
                  </CButton>
                  <CCollapse :show="showFilter === 6">
                    <CCardBody>
                      <CRow>
                        <v-jstree
                          :data="structureList"
                          show-checkbox
                          allow-batch
                          whole-row
                          noDots
                          allow-empty
                          @item-click="itemClick"
                        ></v-jstree>

                        <div
                          class="col-sm-12 col-md-6 col-lg-4 form-group"
                          v-if="deviceList.length > 0"
                        >
                          <label class="typo__label">دستگاه ها</label>
                          <multiselect
                            class="needs-validation"
                            v-model="info.device"
                            :options="deviceList"
                            :allowEmpty="true"
                            :searchable="true"
                            :close-on-select="true"
                            :show-labels="false"
                            placeholder="انتخاب..."
                            :custom-label="nameWithLang"
                            label="label"
                            track-by="value"
                            :multiple="true"
                            @input="updateSensorList()"
                          ></multiselect>
                        </div>

                        <div
                          class="col-sm-12 col-md-6 col-lg-4 form-group"
                          v-if="sensorList.length > 0"
                        >
                          <label class="typo__label">سنسور ها</label>
                          <multiselect
                            class="needs-validation"
                            v-model="info.sensor"
                            :options="sensorList"
                            :allowEmpty="true"
                            :searchable="true"
                            :close-on-select="true"
                            :show-labels="false"
                            placeholder="انتخاب..."
                            :custom-label="nameWithLang"
                            label="label"
                            track-by="value"
                            :multiple="true"
                          ></multiselect>
                        </div>
                      </CRow>
                    </CCardBody>
                  </CCollapse>
                </CCard>

                <CCard class="my-2 p-0" v-if="reportTypeValue.value == 2">
                  <CButton
                    block
                    class="text-right shadow-none card-header"
                    @click="showFilter = showFilter === 6 ? false : 6"
                  >
                    <h5 class="text-primary">فیلتر</h5>
                  </CButton>
                  <CCollapse :show="showFilter === 6">
                    <CCardBody>
                      <CRow>
                        <div class="col-sm-12 col-md-4">
                          <label class="typo__label">مدل</label>
                          <multiselect
                            class="needs-validation"
                            v-model="info.ModelValue"
                            :options="ModelList"
                            :searchable="true"
                            :allow-empty="true"
                            :close-on-select="true"
                            :show-labels="false"
                            placeholder="انتخاب..."
                            label="label"
                            track-by="value"
                            :multiple="true"
                          ></multiselect>
                        </div>

                        <div class="col-sm-12 col-md-4">
                          <label class="typo__label">وضعیت</label>
                          <multiselect
                            class="needs-validation"
                            v-model="info.status"
                            :options="StatusList"
                            :allow-empty="true"
                            :searchable="true"
                            :close-on-select="true"
                            :show-labels="false"
                            placeholder="انتخاب..."
                            label="label"
                            track-by="value"
                            :multiple="true"
                          ></multiselect>
                        </div>

                        <!-- <div role="group" class="col-sm-12 col-md-3 form-group">
                          <label for="uid-vvb5dt2i0jd" class=""
                            >تاریخ شروع </label
                          ><date-picker
                            class="col-sm-12 col-md-3 p-0 m-0"
                            v-model="startDate"
                            :value="startDate"
                          ></date-picker>
                        </div>

                        <div role="group" class="col-sm-12 col-md-3 form-group">
                          <label for="uid-vvb5dt2i0jd" class=""
                            >تاریخ پایان </label
                          ><date-picker
                            class="col-sm-12 col-md-3 p-0 m-0"
                            v-model="endDate"
                            :value="endDate"
                          ></date-picker>
                        </div> -->

                        <v-jstree
                          :data="structureList"
                          show-checkbox
                          allow-batch
                          whole-row
                          noDots
                          @item-click="itemClick"
                          class="my-2"
                        ></v-jstree>

                        <div
                          class="col-sm-12 col-md-6 col-lg-4 form-group"
                          v-if="deviceList.length > 0"
                        >
                          <label class="typo__label">دستگاه ها</label>
                          <multiselect
                            class="needs-validation"
                            v-model="info.device"
                            :options="deviceList"
                            :allowEmpty="true"
                            :searchable="true"
                            :close-on-select="true"
                            :show-labels="false"
                            placeholder="انتخاب..."
                            :custom-label="nameWithLang"
                            label="label"
                            track-by="value"
                            :multiple="true"
                          ></multiselect>
                        </div>
                      </CRow>
                    </CCardBody>
                  </CCollapse>
                </CCard>
              </CRow>
              <CRow>
                <CButton
                  @click="getReport()"
                  class="mt-4 mb-3 btn-warning col-sm-12 col-md-6 col-lg-6"
                  ><CIcon name="cil-print" class="text-dark align-self-center"
                /></CButton>
                <CButton
                  @click="clearSearchItem()"
                  class="mt-4 mb-3 btn-danger col-sm-12 col-md-6 col-lg-6"
                  ><CIcon
                    name="cil-loop-circular"
                    class="text-light align-self-center"
                  />
                </CButton>
              </CRow>
              <CRow v-if="spinner" class="justify-content-center mt-2">
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </CRow>
              <div id="app" style="direction: ltr">
                <div>
                  <div id="viewer"></div>
                </div>
              </div>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import { Values } from "../../commonValues";
import Multiselect from "vue-multiselect";
Vue.component("multiselect", Multiselect);
import VJstree from "vue-jstree-master"; //rtl

const config = {
  timezone: "Asia/Tehran",
  locale: "en",
  fullTextFormat: "W, D N Y H:I:S",
  titleFormat: "W, D N Y",
  dateFormat: "Y-M-D",
  timeFormat: "H:I:S",
};

// Load modules
import { JalaliDateTime } from "jalali-date-time";
const jalali = JalaliDateTime(config);

export default {
  name: "app",
  //props: ["whichReport", "chartData", "date", "sum"],

  components: {
    VJstree,
  },

  data() {
    return {
      showFilter: 0,
      model: [],
      StatusList: [
        {
          label: "آنلاین",
          value: "1",
        },
        {
          label: "آنلاین-آلارم",
          value: "2",
        },
        {
          label: "نیمه آنلاین",
          value: "3",
        },
        {
          label: "آفلاین",
          value: "4",
        },
        {
          label: "غیرفعال",
          value: "5",
        },
        {
          label: "خارج از سرویس",
          value: "6",
        },
      ],
      ModelList: [],

      info: {
        ModelValue: [],
        status: [],
        device: [],
        sensor: [],
      },
      sensorList: [],
      deviceList: [],

      reportTypeList: [
        {
          label: "کاربر",
          value: "1",
        },
        {
          label: "دستگاه",
          value: "2",
        },
      ],
      reportTypeValue: [],
      startDate: "",
      endDate: "",

      spinner: false,

      alert: false,
      alertText: "",

      structureList: [],
      selectedParent: 0,
    };
  },

  mounted() {
    // get status list value from server
    // axios
    //   .get(Values.serverIp + "Constant/GetCarStatusSelectList")
    //   .then((response) => {
    //     //console.log(response.data);
    //     this.StatusList = response.data;
    //   });

    // get model list value from server
    axios
      .get(Values.serverIp + "DeviceType/GetDeviceTypeSelectList")
      .then((response) => {
        console.log(response.data);
        this.ModelList = response.data;
      });

    this.GetOrganizationalStructureTree();

    if (localStorage.getItem("token"))
      axios.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${localStorage.getItem("token")}`;
  },

  methods: {
    //********************************************************************* get organiztion tree */
    GetOrganizationalStructureTree() {
      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(
          Values.serverIp +
            "OrganizationalStructure/GetOrganizationalStructureTree",
          JSON.stringify(""),
          config
        )
        .then((response) => {
          if (response.status == 200) {
            //console.log(response.data);
            this.structureList = response.data;
          } else {
            // modal unsuccessful edit change
            (this.alertModal = true),
              (this.alertModalTitle = "خطایی رخ داده"),
              (this.alertModalText =
                "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید."),
              (this.alertModalColor = "danger"),
              (this.alertModalButtonText = "تایید");
          }
        })
        .catch((response) => {
          if (response.status != 200) {
            // modal unsuccessful edit change
            this.alertModal = true;
            this.alertModalTitle = "خطایی رخ داده";
            this.alertModalText =
              "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
            (this.alertModalColor = "info"),
              (this.alertModalButtonText = "تایید");
          }
        });
    },

    //****************************************************************** select parrent */
    itemClick(node) {
      this.selectedParent = node.model.id;
      //console.log(this.selectedParent);
      this.getDeviceByOrganazionId(node.model.id, 0);
    },

    //***************************************************************** getDeviceByOrganazionId */
    getDeviceByOrganazionId(data, read, selectedDevice, selectedSensor) {
      this.deviceList = [];
      this.info.device = [];
      this.sensorList = [];
      this.info.sensor = [];
      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(
          Values.serverIp +
            "UserDeviceAccessPermission/GetDeviceLevelSelectList",
          JSON.stringify(data),
          config
        )
        .then((response) => {
          if (response.status == 200) {
            this.deviceList = response.data;
            // if (read == 1) {
            //   for (var i = 0; i < this.deviceList.length; i++) {
            //     for (var j = 0; j < selectedDevice.length; j++) {
            //       if (selectedDevice[j] == this.deviceList[i].value)
            //         this.userInfo.device.push(this.deviceList[i]);
            //     }
            //   }

            //   this.updateSensorList(1, selectedSensor);
            // }
          }
        })
        .catch((response) => {
          //console.log("in catch");
          if (response.response.status == 403) {
            // do not have permission
            // modal unsuccessful edit change
            (this.alertModal = true),
              // (this.showPage = false),
              (this.alertModalTitle = "عدم مجوز"),
              (this.alertModalText =
                "شما دارای مجوز دسترسی به این قسمت نمی باشید."),
              (this.alertModalColor = "info"),
              (this.alertModalButtonText = "تایید");
          } else {
            this.alertModal = true;
            this.alertModalTitle = "خطایی رخ داده";
            this.alertModalText =
              "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
            this.alertModalColor = "danger";
            this.alertModalButtonText = "تایید";
          }
        });
    },
    // ************************************************************** updata Sensor List
    updateSensorList(read, selectedSensor) {
      if (this.info.device.length > 0) {
        this.sensorList = [];
        this.info.sensor = [];
        let temp = [];
        for (var i = 0; i < this.info.device.length; i++) {
          temp.push(this.info.device[i].value);
        }

        axios
          .post(
            Values.serverIp +
              "UserDeviceAccessPermission/GetSensorLevelSelectList",
            {
              organizationId: this.selectedParent,
              deviceIds: temp,
            }
          )
          .then((response) => {
            if (response.status == 200) {
              this.sensorList = response.data;
              if (read == 1) {
                for (var i = 0; i < this.sensorList.length; i++) {
                  for (var j = 0; j < selectedSensor.length; j++) {
                    if (selectedSensor[j] == this.sensorList[i].value)
                      this.userInfo.sensor.push(this.sensorList[i]);
                  }
                }
              }
            }
          })
          .catch((response) => {
            //console.log("in catch");
            if (response.response.status == 403) {
              // do not have permission
              // modal unsuccessful edit change
              (this.alertModal = true),
                // (this.showPage = false),
                (this.alertModalTitle = "عدم مجوز"),
                (this.alertModalText =
                  "شما دارای مجوز دسترسی به این قسمت نمی باشید."),
                (this.alertModalColor = "info"),
                (this.alertModalButtonText = "تایید");
            } else {
              this.alertModal = true;
              this.alertModalTitle = "خطایی رخ داده";
              this.alertModalText =
                "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
              this.alertModalColor = "danger";
              this.alertModalButtonText = "تایید";
            }
          });
      } else {
        this.sensorList = [];
        this.info.sensor = [];
      }
    },
    //**************************************************************************** */
    nameWithLang({ label, value }) {
      return `${label}`;
    },
    setCarGroupList(data) {
      this.carGroupList = data;
    },

    clearSearchItem() {
      this.reportTypeValue = [];
      this.info.device = [];
      this.info.sensor = [];
      this.info.ModelValue = [];
      this.info.status = [];
      this.selectedParent = 0;
      this.sensorList = [];
      this.deviceList = [];
      this.GetOrganizationalStructureTree();
    },

    //***************************************************************************** get report */
    getReport() {
      if (this.reportTypeValue == null || this.reportTypeValue.length == 0) {
        this.alert = true;
        this.alertText = "لطفا نوع گزارش را انتخاب نمایید.";
      } else {
        this.spinner = true;
        if (this.reportTypeValue.value == "1") {
          //user

          let tempDevice = [];
          for (var i = 0; i < this.info.device.length; i++) {
            tempDevice.push(this.info.device[i].value);
          }

          let tempSensor = [];
          for (var i = 0; i < this.info.sensor.length; i++) {
            tempSensor.push(this.info.sensor[i].value);
          }

          axios
            .post(Values.serverIp + "Report/GetUserList", {
              organizationId: this.selectedParent,
              deviceLevelList: tempDevice,
              sensorLevelList: tempSensor,
            })
            .then((response) => {
              if (response.status == 200) {
                this.setdata(response.data, jalali.now(), "totalUserList");
                this.spinner = false;
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else if (this.reportTypeValue.value == "2") {
          //device

          let tempModel = [];
          for (var i = 0; i < this.info.ModelValue.length; i++) {
            tempModel.push(this.info.ModelValue[i].value);
          }

          let tempStatus = [];
          for (var i = 0; i < this.info.status.length; i++) {
            tempStatus.push(this.info.status[i].value);
          }

          let tempDevice = [];
          for (var i = 0; i < this.info.device.length; i++) {
            tempDevice.push(this.info.device[i].value);
          }

          axios
            .post(Values.serverIp + "Report/GetDeviceList", {
              organizationId: this.selectedParent,
              deviceLevelList: tempDevice,
              statusIds: tempStatus,
              modelTypeList: tempModel,
            })
            .then((response) => {
              if (response.status == 200) {
                console.log(response.data);
                this.setdata(response.data, jalali.now(), "totalDeviceList");
                this.spinner = false;
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }
    },

    setdata(data, date, whichReport) {
      this.model = data;

      var report = Stimulsoft.Report.StiReport.createNewReport();
      if (whichReport == "totalDistance") {
        report.loadFile("/reports/TotalDistanceReport.mrt");
      } else if (whichReport == "totalFuel") {
        report.loadFile("/reports/TotalFuelReport.mrt");
      } else if (whichReport == "totalStops") {
        report.loadFile("/reports/totalStopReport.mrt");
      } else if (whichReport == "totalUserList") {
        report.loadFile("/reports/totalUserList.mrt");
      } else if (whichReport == "totalDeviceList") {
        report.loadFile("/reports/totalDeviceList.mrt");
      }

      var options = new Stimulsoft.Viewer.StiViewerOptions();
      var viewer = new Stimulsoft.Viewer.StiViewer(options, "StiViewer", false);

      //Activation with using license code
      Stimulsoft.Base.StiLicense.Key =
        "6vJhGtLLLz2GNviWmUTrhSqnOItdDwjBylQzQcAOiHn0s4gy0Fr5YoUZ9V00Y0igCSFQzwEqYBh/N77k4f0fWXTHW5rqeBNLkaurJDenJ9o97TyqHs9HfvINK18Uwzsc/bG01Rq+x3H3Rf+g7AY92gvWmp7VA2Uxa30Q97f61siWz2dE5kdBVcCnSFzC6awE74JzDcJMj8OuxplqB1CYcpoPcOjKy1PiATlC3UsBaLEXsok1xxtRMQ283r282tkh8XQitsxtTczAJBxijuJNfziYhci2jResWXK51ygOOEbVAxmpflujkJ8oEVHkOA/CjX6bGx05pNZ6oSIu9H8deF94MyqIwcdeirCe60GbIQByQtLimfxbIZnO35X3fs/94av0ODfELqrQEpLrpU6FNeHttvlMc5UVrT4K+8lPbqR8Hq0PFWmFrbVIYSi7tAVFMMe2D1C59NWyLu3AkrD3No7YhLVh7LV0Tttr/8FrcZ8xirBPcMZCIGrRIesrHxOsZH2V8t/t0GXCnLLAWX+TNvdNXkB8cF2y9ZXf1enI064yE5dwMs2fQ0yOUG/xornE";

      var dataSet = new Stimulsoft.System.Data.DataSet("Demo");

      // Load report from url
      //report.loadFile("/reports/userReport.mrt");
      dataSet.readJson(this.model);

      report.regData(dataSet.dataSetName, "", dataSet);

      //برای مقادیر ثابت
      report.dictionary.variables.getByName("dateTime").valueObject = date;
      // report.dictionary.variables.getByName("dateRange").valueObject =
      //   this.startDate + " - " + this.endDate;

      report.dictionary.variables.getByName("serverIp").valueObject =
        Values.serverIp;

      report.dictionary.variables.getByName("organizationName").valueObject =
        Values.companyName;

      // Assign report to the viewer, the report will be built automatically after rendering the viewer
      viewer.report = report;
      viewer.renderHtml("viewer");
    },
  },
};
</script>

<style>
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

